// The degrees on a user's profile (Settings > Profile, onboarding; the fields
// are components/onboarding/fields.tsx EducationFields).

// Lowest to highest, as in onboarding/fields.tsx DEGREES
const DEGREE_RANK = ['High school', 'Diploma', "Bachelor's", "Master's", 'PhD'];

/** One degree. Users can list several (two bachelor's, a master's after a bachelor's). */
export type Education = { school: string; program: string; degree: string; gradYear: string };
export const EMPTY_EDUCATION: Education = { school: '', program: '', degree: '', gradYear: '' };

const str = (v: unknown) => (typeof v === 'string' ? v : '');

/** The user doc's `education`, or the single school / program / degree / gradYear saved before it */
export function educationFrom(record: Record<string, any> | null | undefined): Education[] {
  const list = Array.isArray(record?.education) ? record!.education : [];
  const saved: Education[] = list.map((e: any) => ({
    school: str(e?.school),
    program: str(e?.program),
    degree: str(e?.degree),
    gradYear: str(e?.gradYear),
  }));
  if (saved.length) return saved;
  return [{ school: str(record?.school), program: str(record?.program), degree: str(record?.degree), gradYear: str(record?.gradYear) }];
}

/**
 * Fields to save: `education`, plus the single fields the rest of the app reads.
 * school / program / gradYear come from the first entry; degree is the highest
 * one, which is what role matching checks (backend/job_matching.py degree_fits).
 */
export function educationDoc(list: Education[]) {
  const education = list
    .map((e) => ({ school: e.school.trim(), program: e.program.trim(), degree: e.degree, gradYear: e.gradYear }))
    .filter((e) => e.school || e.program || e.degree || e.gradYear);
  const first = education[0];
  const highest = education.reduce<string>(
    (best, e) => (DEGREE_RANK.indexOf(e.degree) > DEGREE_RANK.indexOf(best) ? e.degree : best),
    '',
  );
  return {
    education,
    school: first?.school || null,
    program: first?.program || null,
    degree: highest || null,
    gradYear: first?.gradYear || null,
  };
}

